import React from 'react';
import { useNavigate } from "react-router-dom";
import { useLanguage } from '../../contexts/LanguageContext';
import data from '../../data/data.json';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const StoryBook = () => {
  const { lang, translate } = useLanguage();
  const navigate = useNavigate();
  useDocumentTitle(translate('storyBook'));

  const stories = data.stories || [];

  if (stories.length === 0) {
    return <div className="storybook">{translate('loading_story')}</div>;
  }

  return (
    <div className="storybook">
      <h1 className="visually-hidden">{translate('storyBook')}</h1>
      <div className="storybook-gallery">
        {stories.map((story) => {
          // Only English has PDFs so far. Rather than let a child open
          // seventeen covers and meet "coming soon" every time, show on the
          // card which ones can actually be read.
          const available = Boolean(story.lang?.[lang]?.pdf);

          return (
            <button
              key={story.id}
              type="button"
              className={`storybook-card ${available ? '' : 'unavailable'}`}
              onClick={() => navigate(`/storybook/${story.id}`)}
              aria-label={
                available
                  ? `${translate('storyBook')} ${story.id + 1}`
                  : `${translate('storyBook')} ${story.id + 1} — ${translate('story_unavailable')}`
              }
            >
              <img
                src={story.lang?.[lang]?.cover}
                className="storybook-cover"
                alt=""
                loading="lazy"
              />
              {!available && (
                <span className="storybook-badge">{translate('story_unavailable')}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StoryBook;
